export default [
  {
    id: 1,
    name: 'Chris Cap',
    age: 79,
    job_title: 'Ionic Team is awesome',
    profile_image_url: 'assets/img/people/captain.png',
    images: [
      { id: 0, imageUrl: 'assets/img/people/captain.png' },
      { id: 1, imageUrl: 'assets/img/people/thanos.png' },
      { id: 2, imageUrl: 'assets/img/people/captain.png' },
      { id: 3, imageUrl: 'assets/img/people/thor.png' },
    ]
  },
  {
    id: 2,
    name: 'Electronic Iron',
    age: 50,
    job_title: 'Another awesome Ionic guy',
    profile_image_url: 'assets/img/people/ironman.png',
    images: [
      { id: 0, imageUrl: 'assets/img/people/ironman.png' },
      { id: 1, imageUrl: 'assets/img/people/thanos.png' },
      { id: 2, imageUrl: 'assets/img/people/captain.png' },
      { id: 3, imageUrl: 'assets/img/people/thor.png' },
    ]
  },
  {
    id: 3,
    name: 'Black Scar',
    age: 35,
    job_title: 'Game character assasin',
    profile_image_url: 'assets/img/people/blackwidow.png',
    images: [
      { id: 0, imageUrl: 'assets/img/people/blackwidow.png' },
      { id: 1, imageUrl: 'assets/img/people/thanos.png' },
      { id: 2, imageUrl: 'assets/img/people/captain.png' },
      { id: 3, imageUrl: 'assets/img/people/thor.png' },
    ]
  },
  {
    id: 4,
    name: 'Hieu Pham',
    age: 31,
    job_title: 'UX/UI lover',
    profile_image_url: 'assets/img/people/hieu.png',
    images: [
      { id: 0, imageUrl: 'assets/img/people/hieu.png' },
      { id: 1, imageUrl: 'assets/img/people/thanos.png' },
      { id: 2, imageUrl: 'assets/img/people/captain.png' },
      { id: 3, imageUrl: 'assets/img/people/thor.png' },
    ]
  },
  {
    id: 5,
    name: 'Big Mike',
    age: 72,
    job_title: 'All guys are awesome',
    profile_image_url: 'assets/img/people/thanos.png',
    images: [
      { id: 0, imageUrl: 'assets/img/people/thanos.png' },
      { id: 1, imageUrl: 'assets/img/people/thanos.png' },
      { id: 2, imageUrl: 'assets/img/people/captain.png' },
      { id: 3, imageUrl: 'assets/img/people/thor.png' },
    ]
  },
  {
    id: 6,
    name: 'Big Hammer',
    age: 58,
    job_title: 'Ionic again',
    profile_image_url: 'assets/img/people/thor.png',
    images: [
      { id: 0, imageUrl: 'assets/img/people/thor.png' },
      { id: 1, imageUrl: 'assets/img/people/thanos.png' },
      { id: 2, imageUrl: 'assets/img/people/captain.png' },
      { id: 3, imageUrl: 'assets/img/people/thor.png' },
    ]
  }
];
